import { TablePropertiesDestinationCore } from '../../table/table/properties/table-properties-destination-core';
export class StyleTablePropertiesDestination extends TablePropertiesDestinationCore {
}
